$(document).ready(function () {
  let touchStartX = 0;
  let touchEndX = 0;

  $('.itemframe').on('touchstart', function (e) {
    touchStartX = e.originalEvent.changedTouches[0].screenX;
  });

  $('.itemframe').on('touchend', function (e) {
    touchEndX = e.originalEvent.changedTouches[0].screenX;

    if (touchEndX < touchStartX - 50) {
      updateMainImageByIndex(currentImageIndex + 1);
    }

    if (touchEndX > touchStartX + 50) {
      updateMainImageByIndex(currentImageIndex - 1);
    }
  });

  let currentImageIndex = 0;
  let currentVariant = null;
  var variants = window.ProductData?.variants || [];
  var currentSelections = {};

  const selectedVariantId = new URLSearchParams(window.location.search).get('variant');
  const initialVariant =
    variants.find(v => String(v.id) === String(selectedVariantId)) ||
    variants.find(v => v.id === window.ProductData.selected_or_first_available_variant?.id) ||
    variants[0];

  if (initialVariant && Array.isArray(initialVariant.options)) {
    initialVariant.options.forEach(function (opt, idx) {
      currentSelections[idx] = opt;
    });
  }

  function getVariantPriceNumber(variant, key) {
    if (!variant) return 0;

    const raw = variant[key];

    if (typeof raw === 'number') {
      return raw / 100;
    }

    if (raw) {
      const parsed = parseFloat(String(raw).replace(/[^0-9.]/g, ''));
      if (!isNaN(parsed)) return parsed > 999 ? parsed / 100 : parsed;
    }

    if (key === 'price') {
      const first = parseFloat(String(variant.formatted_price_first || '').replace(/[^0-9.]/g, '')) || 0;
      const centsRaw = String(variant.formatted_price_last || '').replace(/[^0-9]/g, '');
      const cents = centsRaw ? parseInt(centsRaw.slice(0, 2), 10) / 100 : 0;
      return first + cents;
    }

    if (key === 'compare_at_price') {
      const first = parseFloat(String(variant.formatted_compare_at_price_first || '').replace(/[^0-9.]/g, '')) || 0;
      const centsRaw = String(variant.formatted_compare_at_price_last || '').replace(/[^0-9]/g, '');
      const cents = centsRaw ? parseInt(centsRaw.slice(0, 2), 10) / 100 : 0;
      return first + cents;
    }

    return 0;
  }

  function getVariantPriceParts(variant, key) {
    if (!variant) return null;

    if (key === 'price' && (variant.formatted_price_first || variant.formatted_price_last)) {
      return {
        first: String(variant.formatted_price_first || '0').replace(/[^0-9]/g, '') || '0',
        last: String(variant.formatted_price_last || '00').replace(/[^0-9]/g, '').padStart(2, '0').slice(0, 2)
      };
    }

    if (key === 'compare_at_price' && (variant.formatted_compare_at_price_first || variant.formatted_compare_at_price_last)) {
      return {
        first: String(variant.formatted_compare_at_price_first || '0').replace(/[^0-9]/g, '') || '0',
        last: String(variant.formatted_compare_at_price_last || '00').replace(/[^0-9]/g, '').padStart(2, '0').slice(0, 2)
      };
    }

    const price = getVariantPriceNumber(variant, key);
    if (!price) return null;

    const parts = price.toFixed(2).split('.');

    return {
      first: parts[0],
      last: parts[1]
    };
  }

  function getServingSizeFromVariant(variant) {
    const option2 = String(variant?.options?.[1] || '')
      .toLowerCase()
      .replace(/servings?/g, '')
      .trim();

    const match = option2.match(/\d+(\.\d+)?/);
    return match ? parseFloat(match[0]) : 32;
  }

  function updateDisplayedPrice(variant) {
    const mainParts = getVariantPriceParts(variant, 'price');

    if (mainParts) {
      $('#price').text(mainParts.first);
      $('#price-dec').text(mainParts.last);
    }

    const compareParts = getVariantPriceParts(variant, 'compare_at_price');
    const price = getVariantPriceNumber(variant, 'price');
    const comparePrice = getVariantPriceNumber(variant, 'compare_at_price');

    if (compareParts && comparePrice > price) {
      $('#compare-price').text(compareParts.first);
      $('#compare-price-dec').text(compareParts.last);
      $('#compare-price-wrap').show();
    } else {
      $('#compare-price-wrap').hide();
    }
  }

  function updatePerServing(variant) {
    const price = getVariantPriceNumber(variant, 'price');
    const productId = String(window.productId || variant?.product_id || '');
    const servings = productId === '7734102491232' ? 12 : getServingSizeFromVariant(variant);

    if (!price || !servings) return;

    $('#perserv').text((price / servings).toFixed(2));
    $('#servs').text(servings);
  }

  function updateMainImageByIndex(index) {
    const $items = $('.li-list');
    if (!$items.length) return;

    currentImageIndex = (index + $items.length) % $items.length;

    const $item = $items.eq(currentImageIndex);
    const newSrc = $item.find('img').attr('src');

    if (newSrc) {
      $('.img-item').attr('src', newSrc);
      $items.removeClass('list-on');
      $item.addClass('list-on');
    }
  }

  function updateSizeVisibility(selectedVariant) {
    var selectedFlavor = selectedVariant.options[0];

    $('.row-opts').each(function () {
      $(this).find('.opts').each(function () {
        var $opt = $(this);
        var size = $opt.data('item');

        var matchedVariant = variants.find(function (variant) {
          return variant.options[0] === selectedFlavor && variant.options[1] === size;
        });

        if (!matchedVariant) {
          $opt.hide();
        } else {
          $opt.show();

          if (matchedVariant.featured_image && matchedVariant.featured_image.src) {
            $opt.find('img').attr('src', matchedVariant.featured_image.src);
          }
        }
      });
    });
  }

  function handleStockDisplay(variant) {
    const isForcedOOS = variant.metafields?.custom?.force_out_of_stock_?.value;

    if (variant.available && !isForcedOOS) {
      $('.row-oos').hide();
      $('.btn-row').css('display', 'flex');
      $('.buy-box').show();
    } else {
      $('.row-oos').show();
      $('.btn-row,.buy-box').hide();
    }
  }

  function updateURL(variant) {
    if (history.replaceState) {
      var newUrl = `${window.location.pathname}?variant=${variant.id}`;
      history.replaceState(null, '', newUrl);
    }
  }

  function updateImage(variant) {
    if (!variant || !variant.metafields || !variant.metafields.custom) {
      console.warn('Variant or metafields missing', variant);
      return;
    }

    var featuredImage = variant.featured_image && variant.featured_image.src ? variant.featured_image.src : null;

    if (featuredImage) {
      $('.img-item,.item-bar').attr('src', featuredImage);
    }

    var $container = $('.ul-list');
    $container.empty();
    currentImageIndex = 0;

    if (featuredImage) {
      var featuredImgHTML =
        '<li class="li-list list-on">' +
        '<img class="img " src="' + featuredImage + '" alt="">' +
        '</li>';

      $container.append(featuredImgHTML);
    }

    const angles = variant?.metafields?.custom?.product_angles?.value || [];

    angles.forEach(function (angleUrl) {
      const $angleImg = $(`<li class="li-list"><img class="img" src="${angleUrl}" alt=""></li>`);
      $container.append($angleImg);
    });

    const listings = variant?.metafields?.custom?.listing_images?.value || [];

    listings.forEach(function (media) {
      const type = media?.type || 'image';
      const src = media?.src || media?.url || media;
      let $item;

      if (type === 'video') {
        $item = $(`<li class="li-list"><video class="img" autoplay muted loop playsinline webkit-playsinline><source src="${src}" type="video/mp4"></video></li>`);
      } else {
        $item = $(`<li class="li-list"><img class="img" src="${src}" alt=""></li>`);
      }

      $container.append($item);
    });
  }

  function updateVariantSelection(optionIndex, value) {
    currentSelections[optionIndex] = value;

    var matchingVariant = variants.find(function (variant) {
      return variant.options.every(function (opt, idx) {
        return currentSelections[idx] === opt;
      });
    });

    if (!matchingVariant) return;

    currentVariant = matchingVariant;

    var $select = $('form[action*="/cart"] select[name="id"]');
    if ($select.length) {
      $select.val(matchingVariant.id).trigger('change');
    }

    updateSizeVisibility(matchingVariant);
    handleStockDisplay(matchingVariant);
    updateURL(matchingVariant);
    updateImage(matchingVariant);
    updateAvailableSizes(matchingVariant.options[0]);
    updateDisplayedPrice(matchingVariant);
    updatePerServing(matchingVariant);

    $('.labelflav,.varname').text(matchingVariant.options[0]);

    const amazonlink = matchingVariant.metafields?.custom?.amazon_url?.value;

    if (amazonlink) {
      $('#btn-am').attr('href', amazonlink).show();
    } else {
      $('#btn-am').hide();
    }

    const collabico = matchingVariant.metafields?.custom?.collab_logo?.value;

    if (collabico) {
      const imgBack = new Image();

      $(imgBack).on('load', function () {
        $('.var-ico-xl, #collab-logo')
          .attr('src', collabico)
          .show();
      });

      imgBack.src = collabico;
    } else {
      $('.var-ico-xl, #collab-logo').hide();
    }

    const sidesplash = matchingVariant.metafields?.custom?.splash_vertical?.value;

    if (sidesplash) {
      const imgBack = new Image();
      imgBack.src = sidesplash;

      $(imgBack).on('load', function () {
        $('.splash-r').css('right', '-160px');
        setTimeout(function () {
          $('.splash-r').attr('src', sidesplash);
          $('.splash-r').css('right', '0px');
        }, 500);
      });
    } else {
      $('.splash-r').css('right', '-160px');

      setTimeout(function () {
        $('.splash-r').attr('src', '');
      }, 500);
    }

    const nfp = matchingVariant.metafields?.custom?.nutrition_facts?.value;

    if (nfp) {
      $('#nfp').hide();

      const imgnfp = new Image();
      imgnfp.src = nfp;

      $(imgnfp).on('load', function () {
        $('#nfp,#nfp2').attr('src', nfp).show();
      });
    } else {
      $('#nfp').hide();
    }

    const allergens = matchingVariant.metafields?.custom?.allergens?.value;

    if (allergens) {
      $('#allergens').text(allergens);
      $('#row-allergy').show();
    } else {
      $('#allergens').text('');
      $('#row-allergy').hide();
    }

    const ingredients = matchingVariant.metafields?.custom?.other_ingredients?.value;

    if (ingredients) {
      $('#drop-ing').show();
      $('#dd-ing').html(ingredients);
    } else {
      $('#drop-ing').hide();
      $('#dd-ing').html('');
    }

    const fruitImages = matchingVariant.metafields?.custom?.fruit?.value || [];
    const fruit1 = Array.isArray(fruitImages) ? fruitImages[0] || "" : "";
    const fruit2 = Array.isArray(fruitImages) ? fruitImages[1] || "" : "";

    if (fruit1) {
      $(".fuel-spl-top").attr("src", fruit1).show();
    } else {
      $(".fuel-spl-top").hide();
    }

    if (fruit2) {
      $(".fuel-spl").attr("src", fruit2).show();
    } else {
      $(".fuel-spl").hide();
    }

    const mikmak = matchingVariant.metafields?.custom?.mikmak_ids?.value;
    if (mikmak) {
      $('#mmbox').attr('data-mm-ids', mikmak);
      $('#row-mm').show();
    } else {
      $('#row-mm').hide();
    }

    const morepix = matchingVariant.metafields?.custom?.extra_photos?.value;
    if (morepix) {
      $('.frame-video').css('background-image', `url(${morepix})`);
    }

    const color1 = matchingVariant.metafields?.custom?.color_1?.value || '';
    const color2 = matchingVariant.metafields?.custom?.color_2?.value || '';
    const color3 = matchingVariant.metafields?.custom?.color_3?.value || '';
    let color4 = matchingVariant.metafields?.custom?.color_1?.value || '';

    $('[data-bg="1"]').css('background-color', color1);
    $('[data-bg="2"]').css('background-color', color2);
    $('[data-bg="3"]').css('background-color', color3);
    $('[data-bg="4"]').css('background-color', color4);

    $('[data-text="1"]').css('color', color1);
    $('[data-text="2"]').css('color', color2);
    $('[data-text="3"]').css('color', color3);

    $('.fill-2').css('fill', color2);
    $('.stlite, .stlite2').css('fill', color1);
    $('.stdark').css('fill', color3);
    $('.shcolor').css('fill', color1);

    $('.yotpo-sr-bottom-line-summary svg path').each(function () {
      this.style.setProperty('fill', color3, 'important');
      this.style.setProperty('stroke', color3, 'important');
    });

    document.documentElement.style.setProperty('--liquid-wave-color', color1);
  }

  function updateAvailableSizes(selectedFlavor) {
    const hasMultipleOptions = variants[0]?.options?.length > 1;

    if (hasMultipleOptions) {
      $('.opts').each(function () {
        const size = $(this).text().trim();

        const isValid = variants.some(v =>
          v.options[0] === selectedFlavor &&
          v.options[1] === size
        );

        $(this).toggle(isValid);
      });
    } else {
      $('.opts').show();
    }
  }

  let quantity = 1;

  function updateQtyDisplay() {
    $('#qtbuy').val(quantity);
    $('#qtbuy').text(quantity);
    $('[name="quantity"]').val(quantity);
  }

  $('#qtadd').on('click', function () {
    quantity++;
    updateQtyDisplay();
  });

  $('#qtmin').on('click', function () {
    if (quantity > 1) {
      quantity--;
      updateQtyDisplay();
    }
  });

  $(document).on('click', '.li-list', function () {
    $(this).siblings().removeClass('list-on');
    $(this).addClass('list-on');
    const newsrc = $(this).find('img').attr('src');
    $('.img-item').attr('src', newsrc);
  });

  $('.li-top').not('.li-bundle-item').on('click', function () {
    $('.opts').removeClass('hide');
    $(this).find('.var-on').css('color', '');
    $(this).siblings().removeClass('var-on');
    $(this).addClass('var-on');

    const flavor = $(this).data('item');

    const validSizes = variants
      .filter(v => v.options[0] === flavor)
      .map(v => v.options[1]);

    if (validSizes.length > 0) {
      const firstValidSize = validSizes[0];

      $('.opts').removeClass('opt-on');

      $('.opts').each(function () {
        const size = $(this).text().trim();

        if (size === firstValidSize) {
          $(this).addClass('opt-on');
        } else {
          $(this).removeClass('opt-on');
        }
      });

      currentSelections[0] = flavor;
      currentSelections[1] = firstValidSize;

      updateVariantSelection(0, flavor);
      updateVariantSelection(1, firstValidSize);
    } else {
      updateVariantSelection(0, flavor);
    }

    $('.labelflav.varname,.h1-v2,.h2-nfp').text(flavor);
  });

  $('.opts').on('click', function () {
    const value = $(this).text().trim();
    const optionIndex = parseInt($(this).closest('[data-id]').data('id')) - 1;
    updateVariantSelection(optionIndex, value);
    $(this).siblings().removeClass('opt-on');
    $(this).addClass('opt-on');
  });

  $('#varnext').on('click', function () { updateMainImageByIndex(currentImageIndex - 1); });
  $('#varback').on('click', function () { updateMainImageByIndex(currentImageIndex + 1); });

  if (initialVariant) {
    updateVariantSelection(0, initialVariant.options[0]);

    if (initialVariant.options[1]) {
      updateVariantSelection(1, initialVariant.options[1]);

      $('.opts').removeClass('opt-on').filter(function () {
        return $(this).text().trim() === initialVariant.options[1];
      }).addClass('opt-on');
    }

    $('.li-top').not('.li-bundle-item').removeClass('var-on').filter(function () {
      return $(this).data('item') === initialVariant.options[0];
    }).addClass('var-on');
  }
});